import {
  // createActionWithPagination,
  createActionWithNestedPagination,
  generatePaginators,
  getPaginator,
} from 'utils/pagination';
import { createAction } from 'redux-actions';
import * as Api from 'api/reports';
import { report } from 'api/schema';
import queryString from 'query-string';
import keys from 'lodash/keys';

const requestReportsCategories = createAction('REPORTS_CATEGORIES_REQUEST');
const receiveReportsCategories = createAction('REPORTS_CATEGORIES_SUCCESS');
const failReportsCategories = createAction('REPORTS_CATEGORIES_ERROR');

export const getReportsCategories = () => dispatch => {
  dispatch(requestReportsCategories());

  return Api.getReportsCategories().then(
    response => {
      dispatch(receiveReportsCategories(response));
    },
    error => dispatch(failReportsCategories(error)),
  );
};

const placeReportsPaginatorURI = '/v1/places/{id}/reports';
const placeReportsPaginatorEntity = [report];
const placeReportsPaginators = generatePaginators(
  placeReportsPaginatorURI,
  placeReportsPaginatorEntity,
);

const requestPlaceReports = createAction('PLACE_REPORTS_REQUEST');
const receivePlaceReports = createActionWithNestedPagination(
  'PLACE_REPORTS_SUCCESS',
);
const failPlaceReports = createAction('PLACE_REPORTS_ERROR');

export const getPlaceReports = (placeId, query = '') => dispatch => {
  dispatch(requestPlaceReports());

  const paginator = getPaginator(
    placeReportsPaginators,
    placeId,
    placeReportsPaginatorURI,
    placeReportsPaginatorEntity,
    10,
  );

  const parsedQuery = queryString.parse(query);

  keys(parsedQuery).forEach(key => {
    paginator.set(key, parsedQuery[key]);
  });

  return paginator
    .get()
    .then(
      data => dispatch(receivePlaceReports({ placeId, data })),
      error => dispatch(failPlaceReports(error)),
    );
};

const equipmentReportsPaginatorURI = '/v1/equipments/{id}/reports';
const equipmentReportsPaginatorEntity = [report];
const equipmentReportsPaginators = generatePaginators(
  equipmentReportsPaginatorURI,
  equipmentReportsPaginatorEntity,
);

const requestEquipmentReports = createAction('EQUIPMENT_REPORTS_REQUEST');
const receiveEquipmentReports = createActionWithNestedPagination(
  'EQUIPMENT_REPORTS_SUCCESS',
);
const failEquipmentReports = createAction('EQUIPMENT_REPORTS_ERROR');

export const getEquipmentReportsPage = (
  equipmentId,
  query = '',
) => dispatch => {
  dispatch(requestEquipmentReports());

  const paginator = getPaginator(
    equipmentReportsPaginators,
    equipmentId,
    equipmentReportsPaginatorURI,
    equipmentReportsPaginatorEntity,
  );

  const parsedQuery = queryString.parse(query);

  keys(parsedQuery).forEach(key => {
    paginator.set(key, parsedQuery[key]);
  });

  return paginator.get().then(
    data =>
      dispatch(
        receiveEquipmentReports({
          equipmentId,
          data,
        }),
      ),
    error => dispatch(failEquipmentReports(error)),
  );
};

const requestReport = createAction('REPORT_REQUEST');
const receiveReport = createAction('REPORT_SUCCESS');
const failReport = createAction('REPORT_ERROR');
const receiveReportWitnesses = createAction('REPORT_WITNESSES_SUCCESS');
const failReportWitnesses = createAction('REPORT_WITNESSES_ERROR');

export const getReport = reportId => dispatch => {
  dispatch(requestReport());

  Api.getReportWitnesses(reportId).then(
    data => dispatch(receiveReportWitnesses({ reportId, data })),
    error => dispatch(failReportWitnesses(error)),
  );

  return Api.getReport(reportId).then(
    response => dispatch(receiveReport(response)),
    error => dispatch(failReport(error)),
  );
};

const requestToggleWitness = createAction('WITNESS_TOGGLE_REQUEST');
const receiveToggleWitness = createAction('WITNESS_TOGGLE_SUCCESS');
const failToggleWitness = createAction('WITNESS_TOGGLE_ERROR');

export const toggleWitnessReport = (reportId, payload) => dispatch => {
  dispatch(requestToggleWitness());

  return Api.postReportWitness(reportId, payload).then(
    response => {
      dispatch(receiveToggleWitness(response));

      return Api.getReportWitnesses(reportId).then(
        data => dispatch(receiveReportWitnesses({ reportId, data })),
        error => dispatch(failReportWitnesses(error)),
      );
    },
    error => dispatch(failToggleWitness(error)),
  );
};

const requestCreateReport = createAction('NEW_REPORT_REQUEST');
const receiveCreateReport = createAction('NEW_REPORT_SUCCESS');
const failCreateReport = createAction('NEW_REPORT_ERROR');

export const createReport = (equipmentId, payload) => dispatch => {
  dispatch(requestCreateReport());

  return Api.createReport(equipmentId, payload).then(
    response => dispatch(receiveCreateReport(response)),
    error => dispatch(failCreateReport(error)),
  );
};

const requestCreateReportEvent = createAction('NEW_REPORT_EVENT_REQUEST');
const receiveCreateReportEvent = createAction('NEW_REPORT_EVENT_SUCCESS');
const failCreateReportEvent = createAction('NEW_REPORT_EVENT_ERROR');

export const createReportEvent = (id, payload) => dispatch => {
  dispatch(requestCreateReportEvent());

  return Api.createReportEvent(id, payload).then(
    data => dispatch(receiveCreateReportEvent({ id, data })),
    error => dispatch(failCreateReportEvent(error)),
  );
};

const requestResolveReport = createAction('RESOLVE_REPORT_REQUEST');
const receiveResolveReport = createAction('RESOLVE_REPORT_SUCCESS');
const failResolveReport = createAction('RESOLVE_REPORT_ERROR');

export const resolveReport = ({ id, payload }) => dispatch => {
  dispatch(requestResolveReport());

  return Api.resolveReport({ id, payload }).then(
    data => dispatch(receiveResolveReport({ id, data })),
    error => dispatch(failResolveReport(error)),
  );
};
